import { AboutContainer } from "../shared/styledComponents";

const About = () => {
  return (
    <AboutContainer>
      <h2>
        <a href="https://www.thecocktaildb.com/api.php" target="_blank" rel="noreferrer">
          API used *click*
        </a>
      </h2>
    </AboutContainer>
  );
};

export default About;
